// ---------------------------------------------------------------------------
// Filter registry — maps filter type strings to drivers
// ---------------------------------------------------------------------------
//
// Same pattern as field-registry.js and page-registry.js. Page-scoped.

/**
 * Create a filter registry.
 * @returns {import('../../contracts/filters.js').FilterRegistry}
 */
export function createFilterRegistry() {
  /** @type {Map<string, import('../../contracts/filters.js').FilterDriver>} */
  const drivers = new Map();

  /**
   * @param {import('../../contracts/filters.js').FilterDriver} driver
   */
  function register(driver) {
    if (!driver.type || typeof driver.type !== 'string') {
      throw new Error('FilterDriver.type must be a non-empty string');
    }
    if (typeof driver.mount !== 'function') {
      throw new Error(`FilterDriver '${driver.type}': mount must be a function`);
    }
    if (drivers.has(driver.type)) {
      throw new Error(`FilterDriver '${driver.type}' is already registered`);
    }
    drivers.set(driver.type, driver);
  }

  /**
   * @param {string} type
   * @returns {import('../../contracts/filters.js').FilterDriver | undefined}
   */
  function get(type) {
    return drivers.get(type);
  }

  /**
   * @returns {string[]}
   */
  function types() {
    return [...drivers.keys()];
  }

  return { register, get, types };
}
